// In picking-list.component.ts
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { RatingModule } from 'primeng/rating';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ContextMenuModule } from 'primeng/contextmenu';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { UserService } from '../pages/service/user.service'; // <-- Import UserService
import { MessageService } from 'primeng/api';
import { environment } from '../../environments/environment';
import { LoaderService } from '../services/loader.service';
interface PickingListOrderLine {
  itemNumber: string; // <-- Add this line
  itemName: string;
  quantity: number;
  size: string;
  pcs: number;
  itemGroup: string; // <-- Add this line
}

interface PickingListOrder {
  orderNo: string;
  creationDate: string;
  customerName: string;
  orderLines: PickingListOrderLine[];
}

interface PickingListDetails {
  fromDate: string;
  toDate: string;
  picklistNo: string;
  vehicleNo: string;
  driverNo: string;
  route: string;
  orders: PickingListOrder[];
}

@Component({
  selector: 'app-generate-picking-list',
  imports: [
    AutoCompleteModule,
    RouterModule,
    CommonModule,
    TableModule,
    FormsModule,
    ButtonModule,
    ContextMenuModule,
    RippleModule,
    ToastModule,
    ToolbarModule,
    RatingModule,
    InputTextModule,
    TextareaModule,
    SelectModule,
    RadioButtonModule,
    InputNumberModule,
    DialogModule,
    TagModule,
    InputIconModule,
    IconFieldModule,
    ConfirmDialogModule,
  ],
  templateUrl: './customize-route-wise-pickinglist.component.html',
  styleUrls: ['./customize-route-wise-pickinglist.component.scss'],
  providers: [UserService, MessageService], // <-- Provide UserService and MessageService
})
export class CustomizeRouteWisePickinglistComponent implements OnInit {
  item: any;
  itemList: any[] = [];
  totalAmountAfterDiscount = 0;
  @ViewChild('pickingList') pickingListElement!: ElementRef;
div1: string = '';
  supplierDetails = {
    supplerVrno: '',
    coa1: '',
    phno: '',
    coa2: '',
    coa3: '',
    coa4: ''
  };
  customerDetails = {
    customerVrno: '',
    CUA1: '',
    CUA2: '',
    CUA3: '',
    CUA4: '',
    phoneNumber: ''
  };
  pickingListDetails: PickingListDetails = {
  fromDate: '',
  toDate: '',
  picklistNo: '',
  vehicleNo: '',
  driverNo: '',
  route: '',
  orders: []
};

  lineDetails: any[] = [];
  itemsPerPage = 20; // Match generate-invoice pagination
  paginatedContent: any[][] = [];

private flattenAndPaginateOrders() {
  const lines: any[] = [];
  this.pickingListDetails.orders.forEach(order => {
    order.orderLines.forEach((line: any, idx: number) => {
      lines.push({
        orderNo: order.orderNo,
        creationDate: order.creationDate,
        customerName: order.customerName,
        itemName: line.itemName,
        quantity: line.quantity,
        size: line.size,
        pcs: line.pcs,
        orderLineIndex: idx,
        orderLinesLength: order.orderLines.length,
        orderId: order.orderNo + order.creationDate // unique per order
      });
    });
  });

  // Paginate into chunks of 22
  this.paginatedContent = [];
  const pageSize = this.selectedLanguage === 'nl' ? 22 : 22;
for (let i = 0; i < lines.length; i += pageSize) {
    const page = lines.slice(i, i + pageSize);

    // Mark the first line of each order on this page as isFirstOnPage
    let prevOrderId: string | null = null; // <-- Add explicit type
    page.forEach((line, idx) => {
      if (idx === 0 || line.orderId !== prevOrderId) {
        line.isFirstOnPage = true;
        // Count how many lines of this order are on this page
        line.rowspanOnPage = page.filter(l => l.orderId === line.orderId).length;
      } else {
        line.isFirstOnPage = false;
        line.rowspanOnPage = 0;
      }
      prevOrderId = line.orderId;
    });

    this.paginatedContent.push(page);
  }

  // After paginating, filter out empty pages
  this.paginatedContent = this.paginatedContent.filter(page => page.length > 0);
}

  summary = {
    grossValue: 0,
    totalDiscountValue: 0,
    
    vatAmount: 0,
    totalOrderValue: 0
  };

  divisionId: string = '';

  selectedLanguage = 'en';

  labels: { [lang: string]: { [key: string]: string } } = {
    en: {
      pickingListTitle: 'RouteWise Picking List',
      RouteWiseConsodilated: 'RouteWise consolidated Picking List',
      customerName: 'Name',
      fromDate: 'From Date',
      toDate: 'To Date',
      picklistNo: 'Picklist No.',
      vehicleNo: 'Vehicle No.',
      driverNo: 'Driver Name.',
      route: 'Route',
      orderNumber: 'Order No.',
      referenceOrderNumber: 'Reference Order No.',
      customerNo: 'Customer No.',
      date: 'Date',
      lineNo: 'Line No',
      itemNo: 'Item No.',
      quantity: 'Quantity',
      itemName: 'Item Name',
      pcs: 'Pcs',
      size: 'Size',
      packages: 'Packages',
      grossWeight: 'Gross Weight',
      netWeight: 'Net Weight',
      quantityRequired: 'Quantity Required'
    },
    de: {
      pickingListTitle: 'RouteWise-Kommissionierliste',
      RouteWiseConsodilated: 'Konsolidierte Kommissionierliste von RouteWise',
      customerName: 'Name',
      fromDate: 'Von Datum',
      toDate: 'Bis Datum',
      picklistNo: 'Picklist-Nr.',
      vehicleNo: 'Fahrzeug-Nr.',
      driverNo: 'Fahrername.',
      route: 'Route',
      orderNumber: 'Auftragsnr.',
      referenceOrderNumber: 'Referenznr.',
      customerNo: 'Kunden-Nr.',
      date: 'Datum',
      lineNo: 'Pos',
      itemNo: 'ArtNr',
      quantity: 'Menge',
      itemName: 'Bezeichnung',
      pcs: 'Stk',
      size: 'Inhalt',
      packages: 'Pakete',
      grossWeight: 'Bruttogewicht',
      netWeight: 'Nettogewicht',
      quantityRequired: 'Benötigte Menge'
    },
    nl: {
      pickingListTitle: 'RouteWise Picklijst',
      RouteWiseConsodilated: 'Geconsolideerde picklijst van RouteWise',
      customerName: 'Naam',
      fromDate: 'Van datum',
      toDate: 'Tot datum',
      picklistNo: 'Picklijstnr.',
      vehicleNo: 'Voertuignr.',
      driverNo: 'Naam bestuurder.',
      route: 'Route',
      orderNumber: 'Ordernr.',
      referenceOrderNumber: 'Referentie Ordernr.',
      customerNo: 'Klantnr.',
      date: 'Datum',
      lineNo: 'Positie',
      itemNo: 'Artikelnummer',
      quantity: 'Hoeveelheid',
      itemName: 'Omschrijving',
      pcs: 'Stuks',
      size: 'Inhoud',
      packages: 'Pakketten',
      grossWeight: 'Brutogewicht',
      netWeight: 'Nettogewicht',
      quantityRequired: 'Benodigde hoeveelheid'
    }
  };

  constructor(
    private http: HttpClient,
    private router: Router,
    private userService: UserService,
    private location: Location ,
    private loaderService: LoaderService,
    
    private messageService: MessageService // <-- Import MessageService
    // <-- Import Location
  ) {
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state as any;
    this.item = state?.item;
    this.itemList = state?.itemList || [];
  }

  goBack() {
  if (window.history.length > 1) {
    this.location.back();
  } else {
    this.router.navigate(['/Orders1']);
  }
}

  ngOnInit() {
     this.loaderService.show('Fetching Picking List', 'Please wait...');

    const navState = window.history.state;
    console.log('Navigation state:', navState);
    console.log('Item from navigation state:', navState.pickingList);
    const pklId = navState.pickingList?.pklId;
    console.log('Item List from navigation state:', navState.pickingList?.pklId);
    console.log('Item List from navigation state:', navState?.pickingListId);

    console.log('CustomizeRouteWisePickinglistComponent initialized with item:', this.item);
    
    const divisionId = this.userService.getDivisionId() || this.item?.divisionId || '100';
    this.div1 = divisionId;
            if (divisionId === '100') {
            this.selectedLanguage = 'de';
        } else if (divisionId === '400') {
            this.selectedLanguage = 'nl';
        } else {
            this.selectedLanguage = 'en';
        }
    // Remove mock data
    // Call API to get picking list data
   const apiUrl = `${environment.apiUrl}InvoiceAndPicklist/OrderWise/GetPickingList?pklId=${pklId}`;

this.http.get<any>(apiUrl).subscribe({
  next: (response) => {
    setTimeout(() => {
   this.loaderService.hide();
    }, 300); // Slight delay for better UX
   // Map API response to your model
    this.pickingListDetails = {
      fromDate: response.fromDate,
      toDate: response.toDate,
      picklistNo: response.picklistNo,
      vehicleNo: response.vehicleNo,
      driverNo: response.driverName,
      route: response.route || '',
      orders: (response.orderHeaders || []).map((order: any) => ({
        orderNo: order.orderNumber,
        creationDate: order.creationDate,
        customerName: order.customerName,
        orderLines: (order.orderLines || []).map((line: any) => ({
          itemNumber: line.itemNumber,
          itemName: line.itemName,
          quantity: line.quantity,
          size: line.size,
          pcs: line.pcs,
          itemGroup: line.itemGroup // <-- included as requested
        }))
      }))
    };

    // Flatten and paginate for display
    this.flattenAndPaginateOrders();
    this.consolidateItems(); // <-- additional processing
  },

  error: (error: any) => {
 this.loaderService.hide();
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Failed to load picking list data.'
    });
  }
});

  }

  chunkData(data: any[], size: number): any[][] {
        const chunks = [];
        for (let i = 0; i < data.length; i += size) {
            chunks.push(data.slice(i, i + size));
        }
        // If the last chunk is "full", add an empty chunk for summary/footer
        // if (chunks.length && chunks[chunks.length - 1].length === size) {
        //     chunks.push([]);
        // }
        return chunks;
    }

  getTotalAmountAfterDiscount(): number {
    return this.itemList.reduce((sum, item) => sum + item.amountAfterDiscount, 0);
  }
  getGrossValue(): number {
    return (this.itemList || []).reduce((sum, row) => sum + (Number(row.amount) || 0), 0);
  }
  getTotalDiscountValue(): number {
    return (this.itemList || []).reduce((sum, row) => sum + (Number(row.amount) * Number(row.discount) / 100 || 0), 0);
  }
  getNetAmount(): number {
    return (this.itemList || []).reduce((sum, row) => sum + (Number(row.amountAfterDiscount) || 0), 0);
  }
  getVatAmount(): number {
    return (this.itemList || []).reduce((sum, row) => sum + (Number(row.vatAmount) || (Number(row.amountAfterDiscount) * Number(row.vat) / 100) || 0), 0);
  }
  getOrderValue(): number {
    return this.getNetAmount() + this.getVatAmount();
  }
  getTotalQuantity(): number {
    return this.lineDetails.reduce((sum, line) => sum + (Number(line.quantity) || 0), 0);
  }
  getTotalGrossWeight(): number {
    return this.lineDetails.reduce((sum, line) => sum + (Number(line.grossWeight) || 0), 0);
  }
  getTotalNetWeight(): number {
    return this.lineDetails.reduce((sum, line) => sum + (Number(line.netWeight) || 0), 0);
  }
      getAddressLines(address: string): string[] {
        return address ? address.split('|').map(line => line.trim()).filter(line => line) : [];
    }


  printPickingList() {
    this.messageService.add({
      severity: 'success',
      summary: 'Printing Picking List',
      detail: 'Please wait while the picking list is being prepared for printing.',
      life: 3000
    });
    const printContents = this.pickingListElement.nativeElement.innerHTML;
    const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
      .map(node => node.outerHTML)
      .join('\n');
    const popupWin = window.open('', '_blank', 'width=1000,height=800');
    if (popupWin) {
      popupWin.document.open();
      popupWin.document.write(`
        <html>
          <head>
            <title>RouteWise Picking List</title>
            ${styles}
            <style>
              body { background: #fff !important; }
              .invoice-wrapper { box-shadow: none !important; border-radius: 0 !important; margin: 0 !important; padding: 0 !important; width: 100% !important; }
              .p-toolbar, .p-button-sm, .p-button-secondary { display: none !important; }
            </style>
          </head>
          <body onload="window.print(); window.close();">
            ${printContents}
          </body>
        </html>
      `);
      popupWin.document.close();
    }
  }
exportToPDF() {
  this.messageService.add({
    severity: 'success',
    summary: 'Exporting to PDF',
    detail: 'Please wait while the picking list is being prepared for PDF export.',
    life: 3000
  });
  const element = this.pickingListElement.nativeElement;
  html2canvas(element, { scale: 1.5 }).then((canvas) => {
    const imgData = canvas.toDataURL('image/jpeg', 0.95);
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageHeight = pdf.internal.pageSize.getHeight(); // ≈ 297mm
    const pageWidth = pdf.internal.pageSize.getWidth();   // ≈ 210mm

    const imgProps = pdf.getImageProperties(imgData);
    const imgHeight = (imgProps.height * pageWidth) / imgProps.width;

    let position = 0;
    let remainingHeight = imgHeight;

    // Add first page
    pdf.addImage(imgData, 'JPEG', 0, position, pageWidth, imgHeight);
    remainingHeight -= pageHeight;

    // Add more pages only if remaining content is larger than a threshold
    while (remainingHeight > 1) { // 👈 Fix: threshold prevents extra blank page
      position -= pageHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'JPEG', 0, position, pageWidth, imgHeight);
      remainingHeight -= pageHeight;
    }

    pdf.save('RouteWise Picking List.pdf');
  });
}

    
  

  fetchPickingListData(orderNumber: string, companyId: string, divisionId: string) {
    const url = `${environment.apiUrl}InvoiceAndPicklist/generateOutput?companyId=${companyId}&divisionId=${divisionId}&orderNumber=${orderNumber}`;
    this.http.get<any>(url).subscribe(data => {
      // Map supplier details
      this.supplierDetails = {
        supplerVrno: data.supplierDetails?.vrno || '',
        coa1: data.supplierDetails?.coa1 || '',
        phno: data.supplierDetails?.phno || '',
        coa2: data.supplierDetails?.coa2 || '',
        coa3: data.supplierDetails?.coa3 || '',
        coa4: data.supplierDetails?.coa4 || ''
      };

      // Map customer details
      this.customerDetails = {
        customerVrno: data.customerDetails?.customerVrno,
        CUA1: data.customerDetails?.customerAddress,
        CUA2: '',
        CUA3: '',
        CUA4: '',
        phoneNumber: data.customerDetails?.phoneNumber
      };



      // Map line details
      this.lineDetails = (data.lineDetails || []).map((line: any) => ({
        position: line.lineNo,
        itemNo: line.itemNo,
        quantity: line.quantity,
        description: line.description,
        size: line.size || '',
        pcs: line.pcs,
        ppuEUR: line.salesPrice,
        discountPercent: line.discountPercent,
        lineamount: line.lineAmount,
        vatCode: line.vatCode,
        grossWeight: line.grossWeight,
        netWeight: line.netWeight, // <-- ADD THIS LINE
        itemGroup:line.itemGroup

      }));
      // Paginate line details for print pages
      const boldLines = this.lineDetails.filter(item => item.itemGroup === '11000');
      const normalLines = this.lineDetails.filter(item => item.itemGroup !== '11000');
      const sortedLines = [...boldLines, ...normalLines];
 
      // Paginate line details for print pages
      this.paginatedContent = this.chunkData(sortedLines, this.itemsPerPage);
      // Map summary
      this.summary = {
        grossValue: data.summaryLevelData?.grossValue || 0,
        totalDiscountValue: data.summaryLevelData?.totalDiscountValue || 0,
        
        vatAmount: data.summaryLevelData?.vatAmount || 0,
        totalOrderValue: data.summaryLevelData?.orderValue || 0
      };
    });
  }

  getLabel(key: string): string {
    return this.labels[this.selectedLanguage][key] || key;
  }

  consolidatedItems: any[] = [];

  consolidateItems() {
    const map = new Map<string, any>();
    for (const order of this.pickingListDetails.orders) {
      for (const line of order.orderLines) {
        const key = line.itemNumber + '|' + line.size;
        if (!map.has(key)) {
          map.set(key, {
            itemNo: line.itemNumber,
            itemName: line.itemName,
            size: line.size,
            pcs: line.pcs, // <-- Use the pack size from the first occurrence
            quantity: line.quantity,
            itemGroup: line.itemGroup // <-- Add this for bold logic
          });
        } else {
          const existing = map.get(key);
          // Do NOT sum pcs, just keep the first occurrence
          existing.quantity += line.quantity;
        }
      }
    }
    this.consolidatedItems = Array.from(map.values());
  }

  get consolidatedItemsPaginated() {
    const pageSize = this.selectedLanguage === 'nl' ? 22 : 22;
    const items = this.consolidatedItems;
 
    // Sort items: bold (itemGroup === '11000') first, then normal
    const boldItems = items.filter(item => item.itemGroup === '11000');
    const normalItems = items.filter(item => item.itemGroup !== '11000');
    const sortedItems = [...boldItems, ...normalItems];
 
    // Paginate sorted items
    const pages = [];
    for (let i = 0; i < sortedItems.length; i += pageSize) {
      pages.push(sortedItems.slice(i, i + pageSize));
    }
    return pages;
  }

  onLanguageChange() {
    this.flattenAndPaginateOrders();
  }
}